import { render } from "./RestrictionsModal.vue?vue&type=template&id=cdaf8702&scoped=true"
import script from "./RestrictionsModal.vue?vue&type=script&lang=js"
export * from "./RestrictionsModal.vue?vue&type=script&lang=js"

import "./RestrictionsModal.vue?vue&type=style&index=0&id=cdaf8702&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdaf8702"]])

export default __exports__